<template>
    <div>
        <!-- Property lookup modal -->
        <b-modal
            id="modal-property-results"
            ref="modalPropertyResults"
            title="Choose your address"
            size="lg"
            hide-footer
        >
            <div
                v-if="lookupProperties && lookupProperties.length > 0"
                class="property-lookup"
            >
                <div
                    v-for="(property, index) in lookupProperties"
                    :key="index"
                    class="property-item"
                    @click="selectProperty(property)"
                >
                    <span v-if="property.line_1">{{ property.line_1 }}</span>
                    <span v-if="property.line_2">,&nbsp;{{ property.line_2 }}</span>
                </div>
            </div>
        </b-modal>
        <!-- END Property lookup modal -->
    </div>
</template>


<script>
import axios from 'axios';

export default {
    name: 'PostcodeLookup',
    data() {
        return {
            lookupProperties: []
        };
    },
    methods: {
        findAddress(postcode) {
            if (!postcode) {
                this.$emit('pageLoaderRemove');
                this.$refs.modalPropertyResults.hide(); // Show modal
                this.$toasted.error('Please enter a valid postcode to use the postcode locator.');
                return false;
            }
            // const apiPostcode = 'ID11QD'; // This is a test postcode that will not use up our 'lookup allowance'. Once live we can use this.PostcodeSearch
            const apiCall = 'https://api.ideal-postcodes.co.uk/v1/postcodes/'; // ideal postcodes address lookup API call
            const apiKey = 'ak_jpsfinu827OIxLRoME8TIHMrrmJ89'; // our unique API key

            // HTTP request for ideal postcodes API
            return axios
                .get(`${apiCall}${postcode}?api_key=${apiKey}`, {
                    transformRequest: [(data, headers) => {
                        delete headers.common['X-CSRF-TOKEN'];
                        return data;
                    }]
                })
                .then((response) => {
                    this.lookupProperties = response.data.result; // save current data
                    this.$emit('pageLoaderRemove');
                    this.$refs.modalPropertyResults.show(); // Show modal
                })
                .catch((error) => {
                    this.$emit('pageLoaderRemove');
                    this.$refs.modalPropertyResults.hide(); // Show modal
                    this.$toasted.error('There was an error while using the postcode lookup. Please try again or enter your details manually.');
                });
        },
        selectProperty(property) {
            this.$emit('propertySelected', property);
            this.$refs.modalPropertyResults.hide(); // Show modal
        }
    }
};
</script>

<style lang="scss">
// property results modal
.modal {
    &#modal-property-results {
        .modal-dialog {
            .modal-content {
                background: theme-color('light-grey');
            }

            .modal-header {
                background: theme-color('secondary');
            }
        }
    }
}

// property results container
.property-lookup {
    max-height: 40vh;
    overflow-y: auto;
    background: white;
}

// property results item
.property-item {
    cursor: pointer;
    padding: .5rem;
    border-bottom: 1px solid whitesmoke;
}
</style>
